import React from 'react';
import { Clock, Truck, Wrench, Shield, Zap, Battery } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  clock: Clock,
  truck: Truck,
  wrench: Wrench,
  shield: Shield,
  zap: Zap,
  battery: Battery
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-slate-950">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Professional Services
          </h2>
          <p className="text-xl text-gray-400">
            Comprehensive vehicle recovery and roadside assistance services 
            designed to get you back on the road quickly and safely
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="group bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-xl p-8 hover:border-blue-500/50 transition-all duration-300 hover:transform hover:scale-105"
              >
                {/* Icon */}
                <div className="w-16 h-16 bg-blue-600/20 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-600/30 transition-colors duration-300">
                  <IconComponent className="w-8 h-8 text-blue-500" />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-blue-400 transition-colors duration-300">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-400 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-400 mb-6">Need immediate assistance?</p>
          <a 
            href="tel:07803539815"
            className="inline-flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-blue-500/50"
          >
            <span>Call Now for Emergency Service</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
